import { boot } from 'quasar/wrappers'
import logger from 'src/logger'

export default boot(async ( { app } ) => {
  app.config.globalProperties.$logger = logger;

})
